import React, { useCallback, useMemo } from 'react';
import PropTypes from 'prop-types';
import { useLocation } from 'react-router-dom';
import MenuItem from './MenuItem';
import CollapsibleMenuItem from './CollapsibleMenuItem';
import { List } from './MenuStyle';
import { useOidcUser } from '@axa-fr/react-oidc';
import { getOidcConfigName } from 'utils/functions';
import { MENU_ITEMS_QUERY } from './queries';
import { useQueryWithSimpleErrorHandling } from 'hooks';

function Menu({ drawerOpen, withGradient }) {
  const location = useLocation();
  const { oidcUser } = useOidcUser(getOidcConfigName());

  const activeRoute = useCallback(routeName => location.pathname.indexOf(routeName) > -1, [location.pathname]);

  const { data } = useQueryWithSimpleErrorHandling(MENU_ITEMS_QUERY, {
    skip: !oidcUser
  });

  const menuItems = useMemo(() => data?.menuItems || [], [data]);

  return (
    <nav>
      <List>
        {menuItems.map((menu, key) => {
          const menuItemProps = { key, menu, drawerOpen, activeRoute, withGradient };
          return menu.children ? <CollapsibleMenuItem {...menuItemProps} /> : <MenuItem {...menuItemProps} />;
        })}
      </List>
    </nav>
  );
}

Menu.propTypes = {
  drawerOpen: PropTypes.bool.isRequired,
  withGradient: PropTypes.bool.isRequired
};

export default Menu;
